import React, { Component } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
// import StepContent from "@mui/material/StepContent";
import moment from "moment";
import "./Stepper.css";

export default class TicketProcess extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    let step = this.props.statuses.filter(
      (s, i) =>
        i <= this.props.statuses?.length && i >= this.props.statuses?.length - 2
    );
    if (this.props.statuses.length > 2)
      step = [
        {
          id: -1,
          created: "",
          status: "...",
          tracking_number: null,
          receipt: null,
        },
        ...step,
      ];

    return (
      <Box sx={{ width: "100%" }}>
        <Stepper alternativeLabel activeStep={this.props.statuses?.length}>
          {step?.map((step) => (
            <Step key={step.status} title={step.status}>
              <StepLabel>
                <Typography
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "1",
                    WebkitBoxOrient: "vertical",
                    fontSize: "0.7rem",
                  }}
                >
                  {step.status}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.7rem",
                  }}
                >
                  {step.created && (
                    <small>{moment(step.created).format("DD MMMM YYYY")}</small>
                  )}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    );
  }
}
